import { render } from "./ViewTemplate.vue?vue&type=template&id=582dd164"
import script from "./ViewTemplate.vue?vue&type=script&lang=js"
export * from "./ViewTemplate.vue?vue&type=script&lang=js"

import "./ViewTemplate.vue?vue&type=style&index=0&id=582dd164&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__